import { ETICHETTE_MOVIMENTO } from '../gru/scorta';

// Etichette dei movimenti per Colata: come GRU, più "Ordinato".
// Un ordine non cambia la giacenza (variazione 0), ma compare nello Storico come qualsiasi intervento.
// Locale a Colata: ETICHETTE_MOVIMENTO di GRU non si tocca.
export const ETICHETTE_MOVIMENTO_COLATA = {
  ...ETICHETTE_MOVIMENTO,
  ordine: { label: 'Ordinato', tono: 'warn' },
};

/** true per le righe dello Storico che non muovono la giacenza (ordini) */
export const eRigaOrdine = (r) => r?.tipo === 'ordine';
